import { apiGet, apiPost, createOrgApiUrl } from '@/utils/apiUtils'
import type {
  CreateInvitationsResponse,
  InvitationsResponse,
} from '@server/types/responseTypes'

export const fetchInvitations = async (organizationId: string) => {
  const res = await apiGet<InvitationsResponse>(
    createOrgApiUrl(organizationId, 'invitations'),
  )
  return res.data
}

export const createInvitations = async ({
  organizationId,
  invitations,
}: {
  organizationId: string
  invitations: { email: string; role: string }[]
}) => {
  const res = await apiPost<CreateInvitationsResponse>(
    createOrgApiUrl(organizationId, 'invitations'),
    { invitations },
  )
  return res.data
}

export const deleteInvitation = async ({
  organizationId,
  invitationId,
}: {
  organizationId: string
  invitationId: string
}) => {
  await apiPost(
    createOrgApiUrl(organizationId, `invitations/${invitationId}/revoke`),
  )
}
